import React, { useState, useEffect } from "react";
import { ReactSession } from "react-client-session";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
ReactSession.setStoreType("localStorage");


const Track = () => {
  const userId = ReactSession.get("welbeinguserId");
  const queryParameters = new URLSearchParams(window.location.search);
  const orderId = queryParameters.get("id");
  const [order, setOrder] = useState(null);
  const [orderDetails, setOrderDetails] = useState([]);
  const [orderStatusHistory, setOrderStatusHistory] = useState([]);
  const [error, setError] = useState("");
  //console.log("order",order);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchOrderData = async () => {
      if (!orderId) {
        setError('Order ID is missing');
        return;
      }

      try {
        const response = await axios.post('https://api.welbeing.in/orders/order/', {
          order_id: orderId
        });

        if (response.data.status === 'success') {
          const orderData = response.data.data;

          // Optionally process numeric fields if needed
          const processedOrder = {
            ...orderData,
            total: parseFloat(orderData.total),
            gst: parseFloat(orderData.gst),
            shipping: parseFloat(orderData.shipping),
            discount: parseFloat(orderData.discount),
            grand_total: parseFloat(orderData.grand_total),
            order_details: orderData.order_details.map(item => ({
              ...item,
              price: parseFloat(item.price),
              quantity: parseInt(item.quantity)
            }))
          };

          setOrder(processedOrder);
          setOrderDetails(processedOrder.order_details);
          setOrderStatusHistory(processedOrder.order_status);
        } else {
          setError(response.data.error.message || 'Failed to fetch order');
        }
      } catch (err) {
        console.error('Error fetching order data:', err);
        setError(err.message);
      }
    };

    fetchOrderData();
  }, [orderId]);

  const getStatusImage = () => {
    if (!order) return null;
    
    if (order.orderType === 'order') {
      switch (order.status) {
        case 'pending':
        case 'Order Placed':
          return (
            <>
              <img className="success-img img-fluid" src="assets/order/packing.png" alt="vector" />
              <img className="check" src="assets/order/check.svg" alt="check" />
            </>
          );
        case 'Shipped':
          return (
            <>
              <img className="success-img img-fluid" src="assets/order/shipped.png" alt="vector" />
              <img className="check" src="assets/order/check.svg" alt="check" />
            </>
          );
        case 'Delivered':
          return (
            <>
              <img className="success-img img-fluid" src="assets/order/delivered.png" alt="vector" />
              <img className="check" src="assets/order/check.svg" alt="check" />
            </>
          );
        case 'Cancelled':
          return <img className="success-img img-fluid" src="assets/order/cancelled.png" alt="vector" />;
        default:
          return <img className="success-img img-fluid" src="assets/order/cancelled.png" alt="vector" />;
      }
    } else {
      return <img className="success-img img-fluid" src="assets/order/cancelled.png" alt="vector" />;
    }
  };

  if (!order) {
    return <div>Loading order data...</div>;
  }

  // Helper function to safely format numbers
  const formatNumber = (value) => {
    if (typeof value === 'number') {
      return value.toFixed(2);
    }
    if (typeof value === 'string') {
      const num = parseFloat(value);
      return isNaN(num) ? '0.00' : num.toFixed(2);
    }
    return '0.00';
  };


     const processPayment = async(event) => {
    event.preventDefault();
    //console.log("start")
       
    

 
    
navigate("/payment", {
  state: {
    razId: order.raz_id,
    amount: order.grand_total,
    orderId: order.order_id,
    name: order.name,
    phone: order.phonenumber,
    email: order.email,
    address: order.address
  }
});

      }


  return (
    <>
    <Header/>
    <main className="main">
      {/* Top Section Start */}
      <section className="p-0" style={{ marginTop: "200px" }}>
        <div className="success-icon">
          <div className="img-wrap">
            {getStatusImage()}
          </div>

          <div className="success-contain">
            {order.pay_status === 'Success' ? (
              <h1>{order.status}</h1>
            ) : (
              <>
                <h1 className='text-danger'>Payment Failed</h1>
                <a onClick={processPayment} className='btn-solid checkout-btn mb-3 mt-3'>
                  Pay Now<i className='arrow'></i>
                </a>
              </>
            )}
            <h5 className="font-light">Order ID : {order.order_id}</h5>
          </div>
        </div>
      </section>
      {/* Top Section End */}

      {/* Compare Section Start */}
      <section className="section-b-space order-success">
        <div className="container-lg">
          <div className="row g-3 g-md-4 cart">
            <div className="col-md-7 col-lg-7 col-xl-8">
              <div className="cart-wrap">
                <div className="items-list">
                  <table className="table cart-table">
                    <thead>
                      <tr>
                        <th className="d-none d-sm-table-cell">PRODUCT</th>
                        <th className="d-none d-sm-table-cell">PRICE</th>
                        <th className="d-none d-lg-table-cell">QUANTITY</th>
                        <th className="d-none d-xl-table-cell">TOTAL</th>
                      </tr>
                    </thead>

                    <tbody>
                      {orderDetails.map((item, index) => {
                        const subtotal = item.price * item.quantity;
                        return (
                          <tr key={index}>
                            <td>
                              <div className="product-detail">
                                <img className="pr-img" src={`https://api.welbeing.in/uploads/products/${item.img}`} alt="product" />
                                <div className="details">
                                  <h4 className="title-color font-default2">
                                    <a href="#">{item.product}</a>
                                  </h4>
                                </div>
                              </div>
                            </td>

                            <td className="price d-none d-sm-table-cell">₹{formatNumber(item.price)}</td>
                            <td className="price d-none d-lg-table-cell">X{item.quantity}</td>
                            <td className="total d-none d-xl-table-cell">₹ {formatNumber(subtotal)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-md-5 col-lg-5 col-xl-4">
              <div className="summery-box">
                <div className="row g-3 g-lg-4">
                  <div className="col-12">
                    <div className="summery-wrap">
                      <div className="cart-wrap grand-total-wrap">
                        <div>
                          <div className="order-summery-box">
                            <h5 className="cart-title">Cart Totals</h5>
                            <ul className="order-summery">
                              <li>
                                <span>Subtotals:</span>
                                <span>₹ {formatNumber(order.total)}</span>
                              </li>
                              
                              <li>
                                <span>Gst:</span>
                                <span>₹ {formatNumber(order.gst)}</span>
                              </li>

                              <li>
                                <span>Shipping:</span>
                                <span className="theme-color">₹ {formatNumber(order.shipping)}</span>
                              </li>

                              <li>
                                <span>Coupon Discount</span>
                                <span className="font-danger">₹ {formatNumber(order.discount)}</span>
                              </li>

                              <li className="pb-0">
                                <span>Total Amount</span>
                                <span>₹{formatNumber(order.grand_total)}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="summery2">
                      <div className="row g-4">
                        <div className="col-12">
                          <div className="order-summery-box">
                            <h5 className="cart-title">Shipping Address</h5>
                          </div>
                          <ul>
                            <li>{order.name}</li>
                            <li>{`${order.address}, ${order.location} - ${order.pin}`}</li>
                            <li>{order.phonenumber}</li>
                            <li>{order.email}</li>
                          </ul>
                          <div className="order-summery-box mt-3">
                            <h5 className="cart-title">Order Tracking</h5>
                          </div>
                          <ul>
                            {orderStatusHistory.map((statusItem, index) => (
                              <li key={index}>{`${statusItem.order_status} at ${statusItem.time}`}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Compare Section End */}
    </main>
   <Footer />
    </>
    
  );
};

export default Track;